module.exports = __webpack_public_path__ + "static/img/notice3.4a45408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice3.png
// module id = 3AUG
// module chunks = 2